// extracted by mini-css-extract-plugin
module.exports = {"w19amszz":"w19amszz"};